import { render, staticRenderFns } from "./sign-up.vue?vue&type=template&id=5576c8a6&scoped=true&"
import script from "./sign-up.vue?vue&type=script&lang=js&"
export * from "./sign-up.vue?vue&type=script&lang=js&"
import style0 from "./sign-up.vue?vue&type=style&index=0&id=5576c8a6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5576c8a6",
  null
  
)

export default component.exports